
// src/web/components/chat-album-file-item.jsx

import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { 
  List, 
  ListItem, 
  ListItemContent,
} from 'react-toolbox/lib/list'
import Link from 'react-toolbox/lib/link'

class AlbumFileItem extends React.Component {
  showPdf = (file)=> this.props.openPdf(file, true)
  render() {
    const {
      file,
      users,
      openPdf,
    } = this.props

    return (
      <List>
        <ListItem　selectable leftIcon={file.content_type.match(/^application\/pdf/) ? 'picture_as_pdf' :'attach_file'}>
          <ListItemContent>
          {file.content_type.match(/^application\/pdf/) &&
          <div onClick={() => this.showPdf(file)} style={{ height: 72, display: 'flex',flexDirection: 'column', justifyContent: 'center' }}>
            <p style={{ color: 'rgb(33, 33, 33)', fontSize: 16 }}>{file.name}</p>
            <p style={{ color: 'rgb(117, 117, 117)' }}>{file.user.name}</p>
            <p style={{ color: 'rgb(117, 117, 117)', fontSize: 14, paddingTop: 3, whiteSpace: 'normal' }}>{moment(file.created_at).format('LLL')}</p>
          </div> ||
          <Link
            href={file.file.url}
            target={"_blank"}
            rel={"noopener noreferrer"}
            style={{ display: 'inline', textDecoration: 'none' }}
            download={true}>
            <div style={{ height: 72, display: 'flex',flexDirection: 'column', justifyContent: 'center' }}>
              <p style={{ color: 'rgb(33, 33, 33)', fontSize: 16 }}>{file.name}</p>
              <p style={{ color: 'rgb(117, 117, 117)' }}>{file.user.name}</p>
              <p style={{ color: 'rgb(117, 117, 117)', fontSize: 14, paddingTop: 3, whiteSpace: 'normal' }}>{moment(file.created_at).format('LLL')}</p>
            </div> 
          </Link>}
          </ListItemContent>
        </ListItem>
    </List>
    )
  }
}

export default AlbumFileItem


// WEBPACK FOOTER //
// ./src/web/components/album-file-item.jsx